/**
 * Handles weight utilities.
 *
 */
export default class WeightUtility {
	/**
	 * Converts weight in kilograms to pounds and ounces.
	 *
	 * @param weightInKg The weight in kilograms.
	 * @returns The weight in pounds and ounces.
	 */
	public static metricToImperial(weightInKg: number): { lb: number; oz: number } {
		const weightInPounds = weightInKg / 0.45359237;
		let lb = Math.floor(weightInPounds);
		let oz = Math.ceil((weightInPounds - lb) * 16);

		if (oz === 16) {
			oz = 0;
			lb++;
		}

		return { lb, oz };
	}
}
